export default {
  namespaced: true,
  state: () => ({
    appDrawer: true 
  }),
  mutations: {
    SET_APP_DRAWER(state, appDrawer){
      state.appDrawer = appDrawer
    }
  },
  actions: {
    setAppDrawer({ commit }, appDrawer) {
      commit('SET_APP_DRAWER', appDrawer)
    }
  },
  getters: {
    appDrawer(state){
      return state.appDrawer
    }
  }
}
